export const REGULATION = {
  FSA: 2,
  FSC: 5,
};
